import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'
import {useAdvertising} from '@adv-mt/advertising-publift'

export default function AdDisplay({
  ad,
  adType,
  bodyType,
  category,
  fuelType,
  make,
  model,
  pageName,
  search,
  searchTerm,
  section,
  seller,
  tag,
  experimentFlags
}) {
  const {domain} = useContext(Context)

  const {setAdvertisingPageData} = useAdvertising()

  useMount(async () => {
    const [error, pageData] = await domain.get('get_page_data_advertising_use_case').execute({
      ad,
      adType,
      bodyType,
      category,
      fuelType,
      make,
      model,
      pageName,
      search,
      searchTerm,
      section,
      seller,
      tag
    })

    if (!error && pageData)
      setAdvertisingPageData({
        pageData: {
          ...pageData,
          ...(experimentFlags?.length ? {ab_test: experimentFlags} : {})
        }
      })
  })

  return null
}

AdDisplay.displayName = 'AdDisplay'
AdDisplay.propTypes = {
  ad: PropTypes.object,
  adType: PropTypes.shape({
    category1Id: PropTypes.number.isRequired,
    category2Id: PropTypes.number.isRequired,
    category3Id: PropTypes.number,
    offerTypeId: PropTypes.number.isRequired
  }),
  bodyType: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  category: PropTypes.string,
  /**
   * experimentFlags must follow the format: "<flag-name>-on" | "<flag-name>-off"
   */
  experimentFlags: PropTypes.arrayOf(PropTypes.string),
  fuelType: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /**
   * make object, to be handled by the UC
   */
  make: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  }),
  model: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  pageName: PropTypes.string.isRequired,
  search: PropTypes.object,
  searchTerm: PropTypes.string,
  section: PropTypes.string,
  seller: PropTypes.shape({
    contractId: PropTypes.string,
    isDealer: PropTypes.bool,
    isPrivate: PropTypes.bool,
    dealer: PropTypes.shape({
      id: PropTypes.string,
      externalContractId: PropTypes.string,
      name: PropTypes.string,
      phoneNumber: PropTypes.string,
      pack: PropTypes.string,
      externalPageUrl: PropTypes.string,
      stockPageUrl: PropTypes.string,
      logoImageUrl: PropTypes.string,
      storeImageUrls: PropTypes.array,
      services: PropTypes.array,
      location: PropTypes.object
    }),
    user: PropTypes.shape({
      name: PropTypes.string,
      email: PropTypes.string,
      phone: PropTypes.string,
      userId: PropTypes.number,
      avatar: PropTypes.string,
      token: PropTypes.string,
      isEmailConfirmed: PropTypes.bool,
      province: PropTypes.string,
      contractId: PropTypes.string
    })
  }),
  tag: PropTypes.string
}
